import { ReactNode } from "react";

export const Container = ({ children }: { children: ReactNode }) => {
  return (
    <div className="min-h-screen">
      <main className="p-0 md:p-8 max-w-[1600px] mx-auto space-y-6">
        {children}
      </main>
    </div>
  );
};
